import React, { FC, useEffect, useState } from 'react'
import { Alert, Button, Card, Col, Form, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/store'
import * as CurrencyFormat from 'react-currency-format'
import ICatRutas from '../../Interfaces/Catalogos/ICatRutas'
import DSCatRutas from '../../Services/Catalogos/CatRutas.Services'
import DTOCatRutas from '../../DTOs/Catalogos/DTOCatRutas'
import DataTable from 'react-data-table-component'
import { IconContext } from 'react-icons'
import { BsFillPencilFill } from 'react-icons/bs'

interface IProps {}

export const CatRutas: FC<IProps> = (props) => {
  const CatClientes = useSelector((state: RootState) => state.CatClientes.CatClientes)
  const CatProveedores = useSelector((state: RootState) => state.CatProveedores.CatProveedores)
  const CatTipoUnidades = useSelector((state: RootState) => state.CatTipoUnidades.CatTipoUnidades)
  const CatUbicaciones = useSelector((state: RootState) => state.CatUbicaciones.CatUbicaciones)
  const CatServicios = useSelector((state: RootState) => state.CatServicios.CatServicios)
  const [IDRuta, setIDRuta] = useState(0)
  const [IDCliente, setIDCliente] = useState(0)
  const [IDProveedor, setIDProveedor] = useState(0)
  const [IDTipoUnidad, setIDTipoUnidad] = useState(0)
  const [IDOrigen, setIDOrigen] = useState(0)
  const [IDDestino, setIDDestino] = useState(0)
  const [IDServicio, setIDServicio] = useState(0)
  const [Precio, setPrecio] = useState(0)
  const [Costo, setCosto] = useState(0)
  const [Search, setSearch] = useState('')
  const [CatRutas, setCatRutas] = useState<DTOCatRutas[]>([])
  const columnsConcepts = [
    {
      name: 'id',
      width: '80px',
      selector: (row: DTOCatRutas) => row.id,
      sortable: true,
    },
    {
      name: 'Cliente',
      width: '300px',
      selector: (row: DTOCatRutas) => row.sCliente,
      sortable: true,
    },
    {
      name: 'Servicio',
      width: '150px',
      selector: (row: DTOCatRutas) => row.sServicio,
      sortable: true,
    },
    {
      name: 'Precio',
      width: '100px',
      selector: (row: DTOCatRutas) => '$ ' + row.precio,
      sortable: true,
    },
    {
      name: 'Costo',
      width: '100px',
      selector: (row: DTOCatRutas) => '$ ' + row.costo,
      sortable: true,
    },
    {
      name: 'Proveedor',
      width: '300px',
      selector: (row: DTOCatRutas) => row.sProveedor,
      sortable: true,
    },
    {
      name: 'Origen',
      width: '150px',
      selector: (row: DTOCatRutas) => row.sOrigen,
      sortable: true,
    },
    {
      name: 'Destino',
      width: '150px',
      selector: (row: DTOCatRutas) => row.sDestino,
      sortable: true,
    },
    {
      name: 'Tipo Unidad',
      width: '150px',
      selector: (row: DTOCatRutas) => row.sTipoUnidad,
      sortable: true,
    },
    {
      name: 'Editar',
      width: '80px',
      cell: (row: DTOCatRutas) => (
        <div
          style={{ textAlign: 'center', cursor: 'pointer' }}
          onClick={() => {
            showInfo(row)
          }}
        >
          <IconContext.Provider value={{ color: 'blue', size: '21px' }}>
            <BsFillPencilFill />
          </IconContext.Provider>
        </div>
      ),
      sortable: true,
    },
  ]

  const showInfo = (row: DTOCatRutas) => {
    setIDRuta(row.id)
    setIDCliente(row.cliente)
    setIDServicio(row.servicio)
    setPrecio(row.precio)
    setIDProveedor(row.proveedor)
    setCosto(row.costo)
    setIDOrigen(row.origen)
    setIDDestino(row.destino)
    setIDTipoUnidad(row.tipoUnidad)
  }

  const clearForm = () => {
    setIDRuta(0)
    setIDCliente(0)
    setIDServicio(0)
    setPrecio(0)
    setIDProveedor(0)
    setCosto(0)
    setIDOrigen(0)
    setIDDestino(0)
    setIDTipoUnidad(0)
  }

  useEffect(() => {
    loadData()
  }, [])

  const loadData = () => {
    DSCatRutas.Get()
      .then((response) => {
        setCatRutas(response.data)
      })
      .catch((e: Error) => {})
  }

  const saveInfo = () => {
    const data: ICatRutas = {
      id: IDRuta,
      cliente: IDCliente,
      proveedor: IDProveedor,
      tipoUnidad: IDTipoUnidad,
      origen: IDOrigen,
      destino: IDDestino,
      servicio: IDServicio,
      precio: Precio,
      costo: Costo,
      activo: 1,
    }
    DSCatRutas.Append(data)
      .then((response) => {
        loadData()
      })
      .catch((e: Error) => {})
  }

  return (
    <div>
      <Row>
        <Col xs={12}>
          <Card style={{}}>
            <Card.Body>
              <Card.Title style={{ textAlign: 'left' }}>
                <Alert variant='primary'>Rutas</Alert>
              </Card.Title>
              <Row>
                <Col xs={1}>Cliente</Col>
                <Col xs={4}>
                  <Form.Control
                    as='select'
                    onChange={(e) => {
                      setIDCliente(parseInt(e.target.value))
                    }}
                    value={IDCliente}
                    className='form-select form-select-sm'
                  >
                    <option value='0'>-SELECCIONE-</option>
                    {CatClientes
                      ? CatClientes.map((c) => {
                          return (
                            <option key={c.id} value={c.id}>
                              {c.cliente}
                            </option>
                          )
                        })
                      : null}
                  </Form.Control>
                </Col>
                <Col xs={1}>Servicio</Col>
                <Col xs={2}>
                  <Form.Control
                    as='select'
                    onChange={(e) => {
                      setIDServicio(parseInt(e.target.value))
                    }}
                    value={IDServicio}
                    className='form-select form-select-sm'
                  >
                    <option value='0'>-SELECCIONE-</option>
                    {CatServicios
                      ? CatServicios.map((c) => {
                          return (
                            <option key={c.id} value={c.id}>
                              {c.servicio}
                            </option>
                          )
                        })
                      : null}
                  </Form.Control>
                </Col>
                <Col xs={1}>&nbsp;</Col>
                <Col xs={1}>Precio</Col>
                <Col xs={2}>
                  <CurrencyFormat
                    value={Precio}
                    displayType={'input'}
                    thousandSeparator={true}
                    prefix={'$'}
                    onValueChange={(values: any) => {
                      const { value } = values
                      setPrecio(value)
                    }}
                    style={{
                      fontSize: '18px',
                      backgroundColor: '#F5FFED',
                      border: '2px solid #25D05B',
                      width: '150px',
                      textAlign: 'right',
                      borderRadius: '10px',
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col>&nbsp;</Col>
              </Row>
              <Row>
                <Col xs={1}>Proveedor</Col>
                <Col xs={4}>
                  <Form.Control
                    as='select'
                    onChange={(e) => {
                      setIDProveedor(parseInt(e.target.value))
                    }}
                    value={IDProveedor}
                    className='form-select form-select-sm'
                  >
                    <option value='0'>-SELECCIONE-</option>
                    {CatProveedores
                      ? CatProveedores.map((c) => {
                          return (
                            <option key={c.id} value={c.id}>
                              {c.proveedor}
                            </option>
                          )
                        })
                      : null}
                  </Form.Control>
                </Col>
                <Col xs={4}>&nbsp;</Col>
                <Col xs={1}>Costo</Col>
                <Col xs={2}>
                  <CurrencyFormat
                    value={Costo}
                    displayType={'input'}
                    thousandSeparator={true}
                    prefix={'$'}
                    onValueChange={(values: any) => {
                      const { value } = values
                      setCosto(value)
                    }}
                    style={{
                      fontSize: '18px',
                      backgroundColor: '#F5FFED',
                      border: '2px solid #25D05B',
                      width: '150px',
                      textAlign: 'right',
                      borderRadius: '10px',
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col>&nbsp;</Col>
              </Row>
              <Row>
                <Col xs={1}>Origen</Col>
                <Col xs={2}>
                  <Form.Control
                    as='select'
                    onChange={(e) => {
                      setIDOrigen(parseInt(e.target.value))
                    }}
                    value={IDOrigen}
                    className='form-select form-select-sm'
                  >
                    <option value='0'>-SELECCIONE-</option>
                    {CatUbicaciones
                      ? CatUbicaciones.map((c) => {
                          if (c.clasificacion === 1) {
                            return (
                              <option key={c.id} value={c.id}>
                                {c.ubicacion}
                              </option>
                            )
                          }
                        })
                      : null}
                  </Form.Control>
                </Col>
                <Col xs={1}>Destino</Col>
                <Col xs={2}>
                  <Form.Control
                    as='select'
                    onChange={(e) => {
                      setIDDestino(parseInt(e.target.value))
                    }}
                    value={IDDestino}
                    className='form-select form-select-sm'
                  >
                    <option value='0'>-SELECCIONE-</option>
                    {CatUbicaciones
                      ? CatUbicaciones.map((c) => {
                          if (c.clasificacion === 2) {
                            return (
                              <option key={c.id} value={c.id}>
                                {c.ubicacion}
                              </option>
                            )
                          }
                        })
                      : null}
                  </Form.Control>
                </Col>
                <Col xs={1}>Tipo unidad</Col>
                <Col xs={2}>
                  <Form.Control
                    as='select'
                    onChange={(e) => {
                      setIDTipoUnidad(parseInt(e.target.value))
                    }}
                    value={IDTipoUnidad}
                    className='form-select form-select-sm'
                  >
                    <option value='0'>-SELECCIONE-</option>
                    {CatTipoUnidades
                      ? CatTipoUnidades.map((c) => {
                          return (
                            <option key={c.id} value={c.id}>
                              {c.tipoUnidad}
                            </option>
                          )
                        })
                      : null}
                  </Form.Control>
                </Col>
              </Row>
              <Row style={{ paddingTop: '20px' }}>
                <Col>
                  <Button variant='warning' onClick={() => clearForm()}>
                    Nuevo
                  </Button>
                </Col>
                <Col xs={10}>
                  {' '}
                  <Form.Control
                    type='text'
                    size='sm'
                    placeholder='Search...'
                    onChange={(e) => {
                      setSearch(e.target.value)
                    }}
                  />
                </Col>
                <Col>
                  <Button variant='primary' onClick={() => saveInfo()}>
                    Guardar
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <DataTable
                    noHeader
                    defaultSortFieldId={'id'}
                    defaultSortAsc={true}
                    striped={true}
                    dense={true}
                    paginationPerPage={10}
                    pagination
                    highlightOnHover
                    columns={columnsConcepts}
                    data={CatRutas.filter(function (row: DTOCatRutas) {
                      return (
                        row.sCliente.toLowerCase().includes(Search.toLowerCase()) ||
                        row.sProveedor.toLowerCase().includes(Search.toLowerCase()) ||
                        row.sServicio.toLowerCase().includes(Search.toLowerCase()) ||
                        row.sOrigen.toLowerCase().includes(Search.toLowerCase()) ||
                        row.sDestino.toLowerCase().includes(Search.toLowerCase()) ||
                        row.sTipoUnidad.toLowerCase().includes(Search.toLowerCase())
                      )
                    })}
                    pointerOnHover
                  />
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  )
}
